import { EyeIcon } from "@heroicons/react/outline";
import React, { memo } from "react";

import { Button } from "../button";

import { ToggleVersionsProps } from "./types";

export const ToggleVersions: React.FC<ToggleVersionsProps> = memo(
  ({ showVersions, onToggleVersions, versionTotal, standalone }) => {
    if (showVersions || !onToggleVersions || versionTotal! <= 1) {
      return null;
    }
    return (
      <>
        {!standalone && <div className="hidden h-1 w-1 rounded-full bg-gray-300 sm:block" />}
        <div onClick={onToggleVersions}>
          <Button onClick={onToggleVersions} variant="link" size="sm">
            <EyeIcon className="mr-1 inline h-4 w-auto" />
            <span className="hidden sm:inline">Show Previous Versions</span>
            <span className="inline sm:hidden">Versions</span>
          </Button>
        </div>
      </>
    );
  },
);
